import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { TableComponent, connect } from "./tableComponent";
import Sublogin from "./elements/sublogin"
import config from '../config'
import { getSid } from 'src/helpers/session'

class Component extends TableComponent {

  initialState = {}

  makeColumns = () => {
    let columns = [
      {
        Header: "Affiliate Id",
        accessor: "aid",
        minWidth: 150,
        Footer: props => <span class="pull-right">Total:</span>
      }, {
        Header: "Name",
        accessor: "name",
        minWidth: 150,
        Footer: props => <span>{this.props.total.count || 0}</span>
      }, {
        Header: "Email",
        accessor: "email",
        minWidth: 180
      },  {
        Header: "Offers",
        // accessor: "skype",
        id: "skype",
        accessor: d => "Yes",
        minWidth: 180
      }, {
        Header: "Reg date",
        accessor: 'date',
        minWidth: 150,
        // Cell: props => <div>{moment(props.value*1000).format("D MMM YYYY")}</div>,
      }
    ]         
    
    return columns; 
  }
/*{
        Header: "Skype",
        accessor: "skype",
        minWidth: 180
      },*/
  apiPath = "master/checker"

  tableParams = {
    manual: true,
    sorted: [{
      id: "aid",
      desc: true
    }],
    showAll: false,
    defaultPageSize: 50
  }  

  render() {
    return (
      <div>
        {!this.props.state.initial &&         
        
        <div>
          <div class="row table-head-controls">
            <div class="col-3">{this.searchElement("checker-search")}</div>
            <div class="col-9">Search emails or skype names of affiliates.</div>            
          </div>
        </div>
        }
        <div class="row">
          <div class="col-sm-12">
            <div class="box mt-2">{this.reactTable()}</div>
          </div>
        </div>
      </div> 
    );
  }
}

export default connect(Component,"master_checker")

